import React, { useRef } from "react";
import ReactSelect from "react-select";
import { Info } from "lucide-react";
import { useMenuPlacement } from "../../hooks";
import { CopyableInput } from "../CopyableInput";
import { defaultSelectCustomStyles, handleSelectMenuOpen } from "../../utils";
import ToolTip from "../../../../ToolTip/ToolTip";
import { CustomOption } from "./components";
import { SelectProps, SelectItems, SelectValue } from "../../interfaces";

export const Select: React.FC<SelectProps> = (props) => {
  const {
    disabled,
    error,
    isCopyable,
    isRequired,
    items,
    label,
    menuListHeight = 190,
    onChange,
    onInputChange,
    placeholder = "Selecciona una opción",
    tooltipText,
    value,
  } = props;
  const selectRef: React.MutableRefObject<null> = useRef(null);
  const { containerRef, menuPlacement, setIsMenuOpen } = useMenuPlacement({
    isMultiSelect: false,
    menuListHeight,
  });

  return isCopyable ? (
    <CopyableInput
      isRequired={isRequired}
      label={label}
      tooltipText={tooltipText}
      value={(value as SelectValue)?.label || ""}
    />
  ) : (
    <div className="flex w-full flex-col gap-2">
      {label && (
        <div className="flex items-center gap-2">
          <label className="text-sm font-normal text-gray-500">
            {label}{" "}
            {isRequired && (
              <span className="text-xs font-normal text-gray-500">*</span>
            )}
          </label>
          {tooltipText && (
            <ToolTip text={tooltipText}>
              <Info className="h-3 w-3 shrink-0 text-gray-500" />
            </ToolTip>
          )}
        </div>
      )}
      <div ref={containerRef}>
        <ReactSelect
          ref={selectRef}
          onMenuOpen={() => {
            setIsMenuOpen(true);
            handleSelectMenuOpen();
          }}
          onMenuClose={() => setIsMenuOpen(false)}
          classNamePrefix="custom-select"
          menuShouldScrollIntoView={false}
          className="cursor-pointer text-sm font-medium"
          noOptionsMessage={() => "Sin resultados"}
          placeholder={placeholder}
          isDisabled={disabled}
          components={{
            Option: CustomOption,
          }}
          styles={defaultSelectCustomStyles}
          defaultValue={value}
          value={value}
          onChange={onChange}
          onInputChange={onInputChange}
          minMenuHeight={menuListHeight}
          maxMenuHeight={menuListHeight}
          menuPortalTarget={document.body}
          menuPlacement={menuPlacement}
          options={items.map((item: SelectItems | number) => ({
            label: typeof item === "number" ? item : item.name,
            value: typeof item === "number" ? item : item.path,
            isDisabled: typeof item === "number" ? false : item.isDisabled || false,
          }))}
          theme={(theme) => ({
            ...theme,
            borderRadius: 6,
            colors: {
              ...theme.colors,
              primary25: "#FFDEE6",
              primary: "#E5E7EB",
            },
          })}
        />
      </div>
      {error && <label className="text-xs text-red-500">{error}</label>}
    </div>
  );
};
